module.exports = __webpack_public_path__ + "media/images/icons/side_menu_assegnare-1000acd111b3c0dd7f2caf006a7545eb.svg";